const _ = require("lodash");

export default function formatTwoDecimal(val) {
  if (val) {
    let formatFloat = new Intl.NumberFormat().format(parseFloat((val / 100).toFixed(2)))
    let split = formatFloat.split('.')
    let number = split[0]
    let decimal = split[1]
    let result = [number]
    result.push(_.padEnd(decimal, 2, '0'))
    return result.join('.')
  }
  return "0.00"
}
